import { createEvent } from 'effector';
import { type PayoutTicketFilters } from '~/entities/payout';

export const setTicketsFilter = createEvent<PayoutTicketFilters>();
